(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const megaMenuTriggers = document.querySelectorAll('.mega-menu-hover');

  megaMenuTriggers.forEach((trigger) => {
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      megaMenuTriggers.forEach((other) => {
        if (other !== trigger) other.classList.remove('is-open');
      });
      trigger.classList.add('is-open');
    };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => trigger.classList.remove('is-open'), 120);
    };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focusin', open);
    trigger.addEventListener('focusout', (event) => {
      if (!trigger.contains(event.relatedTarget)) scheduleClose();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
